import type { ShopContextType } from "@/types/context-type";
import type { BasicResponse, DataResponse } from "@/types/auth-type";
import { handleAxiosError } from "./handleAxiosError";
import { api } from "./api";
import type { FavoriteType, CartType, FormAnswerType } from "@/types/user-type";
import type { PayloadUpdateCartType } from "@/types/shop-type";

export async function getProducts(): Promise<ShopContextType> {
    const res = await api.get("/shop");
    return res.data;
}

export const createFavoriteRequest = async (
    productId: number,
): Promise<DataResponse<FavoriteType>> => {
    try {
        const response = await api.post("/user/favorite", {
            product_id: productId,
        });
        return response.data;
    } catch (error) {
        throw handleAxiosError(error);
    }
};

export const deleteFavoriteRequest = async (
    id: number,
): Promise<BasicResponse> => {
    try {
        const response = await api.delete(`/user/favorite/${id}`);
        return response.data;
    } catch (error) {
        throw handleAxiosError(error);
    }
};

export const createCartRequest = async (
    productId: number,
    variantId: number | null,
    quantity: number,
    formAnswers?: FormAnswerType[] | null,
): Promise<DataResponse<CartType>> => {
    try {
        const response = await api.post("/user/cart", {
            product_id: productId,
            variant_id: variantId,
            quantity,
            form_answers: formAnswers,
        });
        return response.data;
    } catch (error) {
        throw handleAxiosError(error);
    }
};

export const updateCartRequest = async (
    id: number,
    quantity: number,
    formAnswers?: { name: string; value: string }[] | null,
): Promise<DataResponse<CartType>> => {
    try {
        const payload: PayloadUpdateCartType = { quantity };
        if (formAnswers !== undefined) {
            payload.form_answers = formAnswers;
        }
        const response = await api.put(`/user/cart/${id}`, payload);
        return response.data;
    } catch (error) {
        throw handleAxiosError(error);
    }
};

export const deleteCartRequest = async (
    id: number | "bulk",
    ids?: number[],
): Promise<BasicResponse> => {
    try {
        const response = await api.delete(`/user/cart/${id}`, {
            data: ids ? { ids } : undefined,
        });
        return response.data;
    } catch (error) {
        throw handleAxiosError(error);
    }
};
